import * as React from "react";
import { Box } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { DrawingBomContext } from "../../../DrawingBomContext";
import { drawingMaterialsCols } from "../../../../Components/cols/drawingsMaterialsCols";
import { drawingMcsDataCols } from "../../../../Components/cols/drawingMaterialsMcsDataCols";
import { lightTable } from "../../../../../../../../../../styles/muiProps";
import { secondAxios } from "../../../../../../../../../../api/axios";
import { drawingMaterialsMcsData } from "./materialsTableData";
import { useMcsContext } from "../../../../../MCS.context";
import { useBOMDashboardContext } from "../../../../BOMDashboard.context";

export default function MaterialsTable({ drawing }) {
  const { changeSelectionMaterials } = React.useContext(DrawingBomContext);
  const { plant } = useMcsContext();
  const { tabType } = useBOMDashboardContext();
  // console.log("fromMaterialTableEst", plant.estData);

  const [drawingRevs, setDrawingRevs] = React.useState([]);

  const getDrawingRevisions = async (drawingId) => {
    const res = await secondAxios.get(`drawing/all-revs/${drawingId}`);
    const sortedDrawings =
      res?.data?.sort((a, b) => a.createdAt - b.createdAt) || [];

    // console.log("Drawing Revisions:", sortedDrawings);
    setDrawingRevs(sortedDrawings);
  };

  React.useEffect(() => {
    getDrawingRevisions(drawing.id);
  }, []);

  const data = React.useMemo(() => {
    return (
      [...(drawing.materials || [])]
        // .filter((m) =>
        //   tabType === "pnid"
        //     ? ["valve", "instrument"].includes(m.categoryType?.toLowerCase())
        //     : ["bulk"].includes(m.categoryType?.toLowerCase()),
        // )
        .map((m) =>
          m.description
            ? {
                ...m,
                drawing,
                drawingRevs,
                budgetedCost:
                  plant.estData.find((e) => e.description === m.description)
                    ?.budgetedCost || "",
                totalCost: m.mrqMaterials?.[0]?.poMaterials?.[0]?.cost,
              }
            : {
                ...m,
                drawing,
                drawingRevs,
                description: m?.component + m?.size,
                budgetedCost:
                  plant.estData.find((e) => e.description === m.description)
                    ?.budgetedCost || "",
                totalCost: m.mrqMaterials?.[0]?.poMaterials?.[0]?.cost,
              },
        )
        .sort((a, b) =>
          String(a.tagNumber || a.item).localeCompare(
            String(b.tagNumber || b.item),
            undefined,
            { numeric: true },
          ),
        )
    );
  }, [drawing.materials, drawingRevs]);

  // console.log("After:", data);

  const table = useMaterialReactTable({
    data: drawingMaterialsMcsData(data),

    columns: [...drawingMaterialsCols(data), ...drawingMcsDataCols],
    initialState: {
      sorting: [{ id: "tagNumber", desc: false }],
    },
    enableRowSelection: true,
    ...lightTable,
    // layoutMode: "grid",
    enableStickyHeader: true,
    muiTableContainerProps: { sx: { maxHeight: "400px" } },
    getRowId: (row) => String(row.id),
    // onRowSelectionChange: onRowSelection,
    // state: { rowSelection },
  });

  React.useEffect(() => {
    const selectedMaterialsIds = Object.keys(table.getState().rowSelection);

    const selectedMaterials = selectedMaterialsIds.map((id) => {
      return drawing.materials.find((m) => m.id === id);
    });
    const drawingSelectedMaterials = {};

    drawingSelectedMaterials[drawing.id] = selectedMaterials;
    changeSelectionMaterials(drawingSelectedMaterials);
  }, [table.getState().rowSelection]);

  return (
    <Box sx={{ maxHeight: 400 }}>
      <MaterialReactTable table={table} />
    </Box>
  );
}
